module.exports = __webpack_public_path__ + "static/img/11.d2ef486.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/zh/11.png
// module id = fS1s
// module chunks = 0